import { ColorMethod, LineType } from '@/plugins/cad/module/CADModule/model/common/constant'

/**
 * CAD 图层的公共契约字段。
 */
export interface ILayer {
  /** 图层唯一 id */
  id: string
  /** 图层显示名称 */
  name: string
  /** 颜色取值方式 */
  colorMethod: ColorMethod
  /** 颜色值，格式由 colorMethod 决定 */
  color: number
  /** 线型 */
  lineType: LineType
  /** 线宽，单位毫米 */
  lineWidth: number
  /** 是否可见 */
  visible: boolean
  /** 是否锁定，锁定后不可编辑 */
  locked: boolean
}

/**
 * 图层实体，承载图层默认渲染属性与状态。
 */
export class Layer implements ILayer {
  /** 图层唯一 id */
  id!: string
  /** 图层显示名称 */
  name!: string
  /** 颜色取值方式，默认 RGB */
  colorMethod: ColorMethod = ColorMethod.RGB
  /** 颜色值，格式由 colorMethod 决定，默认白色 */
  color: number = 0xffffff
  /** 线型，默认实线 */
  lineType: LineType = LineType.Solid
  /** 线宽，单位毫米，默认 0.25 */
  lineWidth: number = 0.25
  /** 是否可见，默认 true */
  visible: boolean = true
  /** 是否锁定，默认 false */
  locked: boolean = false

  constructor(data: Partial<Layer>) {
    Object.assign(this, data)
  }

  /**
   * 序列化图层为纯对象。
   *
   * @returns 可持久化的纯对象
   */
  serialize() {
    return {
      id: this.id,
      name: this.name,
      colorMethod: this.colorMethod,
      color: this.color,
      lineType: this.lineType,
      lineWidth: this.lineWidth,
      visible: this.visible,
      locked: this.locked,
    }
  }
}
